import React from 'react'

import Image, { ImageProps } from 'next/image'

export interface ImageFitProps extends ImageProps {
  src: string
  alt: string
  blurSrc?: string
  errorSrc?: string
  blur?: boolean
  priority?: boolean
  sizes?: string
  objectFit?: 'contain' | 'cover' | 'fill' | 'none' | 'scale-down'
}

export const ImageFit: React.FC<ImageFitProps> = ({
  src,
  alt,
  errorSrc,
  blurSrc,
  blur = false,
  priority,
  sizes = '100%, 100%',
  objectFit = 'contain',
  ...rest
}) => {
  const [source, setSource] = React.useState(src)
  return (
    <Image
      src={source}
      alt={alt}
      placeholder={blur ? 'blur' : 'empty'}
      blurDataURL={blurSrc ? blurSrc : source}
      sizes={sizes}
      fill={true}
      style={{
        objectFit,
        objectPosition: 'center',
      }}
      priority={priority}
      onError={() => setSource(errorSrc ? errorSrc : source)}
      {...rest}
    />
  )
}
